var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modal",staticClass:"ui modal"},[_c('div',{staticClass:"content"},[_vm._v("\n\t\tIzbrana gradiva so dodana v vašo iZbirko. \n\t")]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui yellow button approve",on:{"click":_vm.close}},[_vm._v("V iZbirko")])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e86891b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/modals/FreeSuccess.vue
// module id = EqzV
// module chunks = 0